export function parseItinerary(itinerary) {
  const journeySegments = [];
  const segments = itinerary.split('~');
  for (const segment of segments) {
    const [from, departureDatetime, , , to] = segment.split('*');
    journeySegments.push({ from, to, departureDatetime });
  }
  return journeySegments;
}
